import { format as formatFns, parse as parseFns, isValid } from "date-fns";

/** date-fns display + MUI `DatePicker` + `AdapterDateFns` (see `src/index.js`) */
export const DATE_DISPLAY_FORMAT = "dd/MM/yyyy";
export const DATE_API_FORMAT = "yyyy-MM-dd";

/**
 * MUI `DatePicker` with `AdapterDayjs` only — dayjs tokens differ (use DD not dd for day of month).
 * Prefer the app-wide `AdapterDateFns` + `DATE_DISPLAY_FORMAT` instead of mixing adapters.
 */
export const MUI_DAYJS_PICKER_FORMAT = "DD/MM/YYYY";

/**
 * Format a Date (or date-like value) to dd/MM/yyyy (or a custom format).
 */
export function formatDate(value, fmt = DATE_DISPLAY_FORMAT) {
  if (value == null || value === "") return "";
  const d = value instanceof Date ? value : new Date(value);
  if (!isValid(d)) return "";
  return formatFns(d, fmt);
}

/**
 * Parse a dd/MM/yyyy string into a Date.
 * Returns null when invalid.
 */
export function parseDate(value, fmt = DATE_DISPLAY_FORMAT) {
  if (value == null || value === "") return null;
  if (value instanceof Date) return isValid(value) ? value : null;
  if (typeof value !== "string") return null;
  const parsed = parseFns(value, fmt, new Date());
  return isValid(parsed) ? parsed : null;
}

/**
 * Safe display helper: returns a human-friendly dd/MM/yyyy string or "—".
 */
export function displayDate(value, fallback = "—") {
  const out = formatDate(value, DATE_DISPLAY_FORMAT);
  return out || fallback;
}

/** Convert a picked date into API-friendly YYYY-MM-DD (or empty string). */
export function toApiDate(value) {
  if (value == null || value === "") return "";
  const d = value instanceof Date ? value : new Date(value);
  if (!isValid(d)) return "";
  return formatFns(d, DATE_API_FORMAT);
}

